import { render, staticRenderFns } from "./AdminEmailChange.vue?vue&type=template&id=e37b15cc"
import script from "./AdminEmailChange.vue?vue&type=script&lang=ts"
export * from "./AdminEmailChange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports